// @flow
/* stylelint-disable no-descending-specificity */

import styled, { css, keyframes } from 'styled-components';
import type { Theme } from '../../../types';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const hide = css`
  opacity: 0;
  height: 0;
  transform: scale(0);
`;

const show = css`
  opacity: 1;
  height: auto;
  transform: scale(1);
`;

export const Overlay = styled<any, Theme>('div')`
  position: fixed;
  ${hide}
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.theme.menu.desktop.overlayColor};
  z-index: 9998;
`;

export const StyleWrapper = styled<any, Theme>('section')`
  &:hover + .overlay {
    ${show}
    /*Hide overlay on ie11*/
    @media all and (-ms-high-contrast:none) {
      ${hide}
    }
    animation: ${fadeIn} 0.2s linear;
  }

  &:hover {
    ul.level-0 > li:not(:hover) > a {
      color: ${props => props.theme.menu.desktop.overlayLinkColor};

      /*Because overlay is hidden on ie11 the not hoverd links don't get the overlayLinkColor*/
      @media all and (-ms-high-contrast:none) {
        color: ${props => props.theme.menu.desktop.linkColor};
      }
    }
  }

  a {
    display: inline-block;
    color: ${props => props.theme.menu.desktop.linkColor};
    text-decoration: none;
    white-space: nowrap;
    padding: 0.5rem 1rem;
    &:hover, &.active, &.has-active-child {
      color: ${props => props.theme.menu.desktop.linkHoverColor};
    }
  }
  nav {
    min-height: 2.375rem;
    display: flex;
    align-items: center;
  }
  ul {
    position: absolute;
    z-index: 9999;
    list-style: none;
    margin: 0;
    padding: 0;
    &.level-0 {

      > li.has-children {
        position: relative;
      }
      > li {
        display: inline-block;
        &:hover {
          background-color: ${props => props.theme.menu.desktop.backgroundHoverColor};
          border-radius: ${props => props.theme.menu.desktop.borderRadius};
          .level-1 {
            ${show}
          }
        }
        &.has-children:hover {
          border-radius:
            ${props => props.theme.menu.desktop.borderRadius}
            ${props => props.theme.menu.desktop.borderRadius}
            0 0
          ;
        }
      }
      .level-1 {
        ${hide}
      }
    }

    &.level-1 {
      padding: 0.5rem 0;
      position: absolute;
      left: 0;
      top: 100%;
      background-color: ${props => props.theme.menu.desktop.levelOne.backgroundColor};
      border-radius:
        0
        ${props => props.theme.menu.desktop.borderRadius}
        ${props => props.theme.menu.desktop.borderRadius}
        ${props => props.theme.menu.desktop.borderRadius}
      ;
      > li {
        &.has-children {
          > a {
            position: relative;
            .arrow {
              position: absolute;
              top: 50%;
              right: 1rem;
              border: solid ${props => props.theme.menu.desktop.linkColor};
              border-width: 0 0.1rem 0.1rem 0;
              display: inline-block;
              padding: 0.25rem;
              transform: translateY(-50%) rotate(-45deg);
            }
          }
          &:hover {
            .arrow {
              border-color: ${props => props.theme.menu.desktop.linkHoverColor};
            }
            .level-2 {
              ${show}
            }
          }
        }
        > a {
          padding-right: 4rem;
          display: block;
          &:hover, &.active, &.has-active-child {
            background-color: ${props => props.theme.menu.desktop.levelOne.backgroundHoverColor};
          }
        }
      }
      .level-2 {
        ${hide}
      }
    }

    &.level-2 {
      top: 0;
      bottom: 0;
      left: calc(100% - ${props => props.theme.menu.desktop.borderRadius});
      background-color: ${props => props.theme.menu.desktop.levelTwo.backgroundColor};
      border-radius: 0 ${props => props.theme.menu.desktop.borderRadius} ${props => props.theme.menu.desktop.borderRadius} 0;
      > li {
        background-color: ${props => props.theme.menu.desktop.levelTwo.backgroundColor};
        &:last-child {
          border-radius: 0 0 ${props => props.theme.menu.desktop.borderRadius} ${props => props.theme.menu.desktop.borderRadius};
          padding-bottom: 0.5rem;
        }
        &:first-child {
          border-radius: ${props => props.theme.menu.desktop.borderRadius};
          padding-top: 0.5rem;
        }
        > a {
          display: block;
          font-weight: lighter;
        }
      }
    }
  }
`;

export default StyleWrapper;
